export  const Fronted_Roles = [
  "super_admin",
  "super_distributor",
  "distributor",
  "retailer",
  "customer",
];
export const ROLE_CREATE_PERMISSION = {
  super_admin: ["super_distributor", "distributor", "retailer"],
  super_distributor: ["distributor","retailer"],
  distributor: ["retailer"],
  retailer: [],
};
